import React from 'react';
import GettingStarted from './GettingStarted';
import StayingFocused from './StayingFocused';
import ViewScholarships from './ViewScholarships';
import EarnScholarships from './EarnScholarships';
import CheckBack from './CheckBack';
import CashIn from './CashIn';
// import EventsResources from './EventsResources';
// import Resume from './Resume';
// import CheckIn from './CheckIn';
import Goals from './Goals';
import Congrats from './Congrats';

const commonSteps = {
  goals: Goals,
  congrats: function UndergraduateCongrats() {
    return (
      <Congrats claimAccountScholarshipText="Choose a goal to aim for over the next 3 months" />
    );
  },
};
export const STEPS = {
  'getting-started': GettingStarted,
  'staying-focused': StayingFocused,
  // 'events-resources': EventsResources,
  // 'resume': Resume,
  // 'check-in': CheckIn,
  ...commonSteps,
};

export const STEPSV2 = {
  'view-scholarships': ViewScholarships,
  'earn-scholarships': EarnScholarships,
  'check-back': CheckBack,
  'cash-in': CashIn,
  ...commonSteps,
};

export const getSteps = (flag) => {
  if (flag) {
    return {
      'view-scholarships': ViewScholarships,
      'earn-scholarships': EarnScholarships,
      'check-back': CheckBack,
      'cash-in': CashIn,
      ...commonSteps,
    };
  } else return STEPS;
};

export const GOALS = [
  {
    name: 'Choose a career path',
    emoji: '💼',
  },
  {
    name: 'Develop a social network',
    emoji: '💛',
  },
  {
    name: 'Get an A on an exam',
    emoji: '✍️',
  },
  {
    name: 'Join a club or activity',
    emoji: '🎭',
  },
  {
    name: 'Choose a major',
    emoji: '🎓',
  },
  {
    name: 'Apply for internships',
    emoji: '📥',
  },
  {
    name: 'Meet with advisor',
    emoji: '👨‍💼',
  },
  {
    name: 'Balance courseload',
    emoji: '📚',
  },
  {
    name: 'Discover 3 school resources',
    emoji: '🏢',
  },
  {
    name: 'Attend 3+ campus events',
    emoji: '📅',
  },
  {
    name: 'Master another language',
    emoji: '💬',
  },
  {
    name: 'Turn in work on time',
    emoji: '⏰',
  },
  {
    name: 'Learn to budget',
    emoji: '💳',
  },
  {
    name: 'Befriend a professor',
    emoji: '👩‍🏫',
  },
  {
    name: 'Pass all classes',
    emoji: '⭐️',
  },
];
